import cx from 'classnames';

import LoadingSpinner from '@app/components/LoadingSpinner';

interface RootLoadingSpinnerComponentProps {
  isLoading: boolean;
  isOverlay: boolean;
  testId?: string;
}

const defaultProps = {
  isLoading: false,
  isOverlay: false,
};

function RootLoadingSpinnerComponent({
  isLoading,
  isOverlay,
  testId,
}: RootLoadingSpinnerComponentProps) {
  if (!isLoading) {
    return null;
  }

  const className = cx({
    Overlay: true,
    'Overlay--high-z-index': true,
    'Overlay--active': isOverlay,
  });

  return (
    <div>
      <div className={className}>
        <div className="LoadingSpinner__spinner">
          <LoadingSpinner color="white" testId={testId} />
        </div>
      </div>
    </div>
  );
}

RootLoadingSpinnerComponent.defaultProps = defaultProps;

export default RootLoadingSpinnerComponent;
